import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

export function BackButton({ fallbackUrl, children, className, ...props }) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else if (fallbackUrl) {
      navigate(fallbackUrl);
    }
  };

  return (
    <Button
      variant="link"
      className={`p-0 text-decoration-none ${className || ''}`}
      onClick={handleBack}
      {...props}
    >
      {children || <span>&larr; Back</span>}
    </Button>
  );
}
